import React,{useState} from 'react'
import ComanServices from '../../services/ComanServices';
import { useEffect } from 'react';
import { SITE_PHONE, SITE_EMAIL, SITE_ADDRESS, SITE_MAP_URL } from './siteContact';
function Contact() {
   const [contactData, setContactData] = useState()

   useEffect(() => {
     ComanServices.getContact().then((response) => {
       console.log(response)
       setContactData(response?.data)
     }).catch((error) => {
       console.log(error)
     })
   }, [])
    return (
        <div className="ct-page">
          
          {/* get-touch-section-start */}
          <div className="contact-us-section py-70">
            <div className="container">
              <div className="get-in-touch-section">
                <h2 className="heading text-center d-block mb-3">Get in touch</h2>
                <p className="descp text-center px-5">{contactData?.message}</p>
                <div className="get-in-touch-inner my-5">
                  <div className="row gy-4">
                    <div className="col-lg-4 col-sm-6">
                      <div className="contact-us-box">
                        <div className="contact-us-icon-outer">
                          <div className="contact-us-icon-inner">
                            <img src="img/call-icon.svg" alt="Call" />
                          </div>
                        </div>
                        <h4 className="text-center">Call Us:</h4>
                        <h5><a href={`tel:+91${SITE_PHONE}`}>+91 {SITE_PHONE}</a></h5>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                      <div className="contact-us-box">
                        <div className="contact-us-icon-outer">
                          <div className="contact-us-icon-inner">
                            <img src="img/email-icon.svg" alt="Email" />
                          </div>
                        </div>
                        <h4 className="text-center">Email Us:</h4>
                        <h5><a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a></h5>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <div className="contact-us-box">
                        <div className="contact-us-icon-outer">
                          <div className="contact-us-icon-inner">
                            <img src="img/building-icon.svg" alt="Office" />
                          </div>
                        </div>
                        <h4 className="text-center">Office Address:</h4>
                        <h5><a href={SITE_MAP_URL} target="_blank" rel="noopener noreferrer">{SITE_ADDRESS}</a></h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* get-touch-section-end */}
          {/* message-section-start */}
          <section className="contact-form-section banner-new-bg pb-60">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-7">
                  <div className="career-form-section-left contact-us-left-content">
                    <h2 className="heading mb-2">Get in touch</h2>
                    <p className="descp">Please fill the below form to schedule a one to one counselling session<br /> with our experts.</p>
                    <div className="career-form-section-img mt-3">
                      <img src="img/get-in-touch-img.svg" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="career-form-section-right">
                    <div className="career-form-inner students-info-right">
                      <form>
                        <div className="input-field">
                          <input type="text" name="name" className="form-control" placeholder="Name" />
                        </div>
                        <div className="input-field">
                          <input type="email" name="email" className="form-control" placeholder="Email" />
                        </div>
                        <div className="input-field">
                          <input type="text" name="phone" className="form-control" placeholder="Mobile No." />
                        </div>
                        <div className="input-field">
                          <input type="text" name="city" className="form-control" placeholder="City" />
                        </div>
                        <div className="input-field type-file-field">
                          <textarea className="form-control" id="exampleFormControlTextarea1" rows={3} placeholder="Message" defaultValue={""} />
                        </div>
                        <button type="submit">SUBMIT</button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* message-section-end */}
          {/* footer-section-start */}
          
          {/* footer-section-end */}
        </div>
      );
}

export default Contact